<script setup>
const props = defineProps({
  sections: Array,
  isInsight: Boolean,
  insightData: Object,
});

const route = useRoute();
function camelCaseToWords(s) {
  const result = s.replace(/([A-Z])/g, " $1");
  return result.charAt(0).toUpperCase() + result.slice(1);
}

const debug = computed(() => useRoute().query.sections !== undefined);

const sectionsContainer = ref(null);
const { isMobileOrTablet } = useDevice();
const { width: innerWidth } = useWindowSize();

const isMobile = computed(() => {
  if (process.server) return isMobileOrTablet;
  return innerWidth.value < 900;
});

const { height: containerHeight } = useElementSize(sectionsContainer);

const slideWidth = computed(() => {
  if (!isMobile.value) {
    return props.people.length <= 2 ? "var(--cols-6)" : "var(--cols-3)";
  }
  return "calc(var(--cols-4) - var(--grid-gap))";
});
</script>

<template>
  <div
    class="insight-sections-wrapper relative flex flex-col gap-[var(--grid-gap)] lg:flex-row lg:px-bleed"
    ref="sectionsContainer"
  >
    <div v-if="!isMobile" class="sticky-wrapper w-cols-6 shrink-0">
      <component-element-sticky-insight
        v-if="isInsight && !isMobile"
        :insight-data="insightData"
        :container-height="containerHeight"
      />
    </div>
    <div
      v-else-if="isMobile && insightData?.authors?.length > 0"
      class="authors relative mt-spacing-section w-full overflow-clip"
    >
      <client-only>
        <component-element-embla-carousel
          :slide-width="
            innerWidth < 768
              ? 'calc(var(--cols-4) - var(--grid-gap))'
              : 'var(--cols-6)'
          "
          :has-navigation="false"
          type="case"
          class="relative w-full"
        >
          <component-element-insight-people-card
            v-for="(item, index) in insightData.authors"
            :key="index"
            :has-background="true"
            v-bind="item"
            class="embla__slide h-full min-w-0"
            :class="{ 'ml-[var(--grid-gap)]': index !== 0 }"
        /></component-element-embla-carousel>
      </client-only>
    </div>
    <div
      class="sections my-spacing-section flex w-full flex-col gap-spacing-section px-bleed md:my-spacing-section-desktop md:gap-spacing-section-desktop lg:w-cols-6 lg:px-0"
    >
      <component-section
        v-for="({ id, type, data }, idx) in sections"
        :data-module-name="debug ? camelCaseToWords(type) : null"
        :class="{ 'debug-module': debug }"
        :type="type"
        :data="data"
        :idx="idx"
        :id="id"
      />
    </div>
  </div>
</template>
